import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { TextField } from "@mui/material";

export const FormInputDate = ({
  name,
  control,
  label,
  errors,
  defaultValue,
  mandatory,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || null}
      render={({ field, fieldState }) => (
        <DatePicker
          label={label}
          value={field.value ? dayjs(field.value) : null}
          onChange={(date) => field.onChange(date)}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!fieldState.error,
              helperText: fieldState.error?.message,
              required: mandatory === "true",
            },
          }}
        />
      )}
    />
  );
};
